export enum DownloadType {
  Release = 'RELEASE',
  Experimental = 'EXPERIMENTAL',
  ServicePack = 'SERVICEPACK',
  Internal = 'INTERNAL'
}
